import React, { useState } from 'react';
import './AdminLogin.css';

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const correctPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'LoveYour401k2024!';
    const correctUsername = process.env.REACT_APP_ADMIN_USERNAME || 'admin';

    if (username === correctUsername && password === correctPassword) {
      sessionStorage.setItem('admin_authenticated', 'true');
      setError('');
      onLogin(true);
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-badge">Admin</div>
        <h1>Love Your 401(k)</h1>
        <h2>Administrative Access</h2>
        <p className="admin-subtitle">
          Enter your admin credentials to continue
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            autoFocus
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />

          {error && <div className="error">{error}</div>}

          <button type="submit">Sign In</button>
        </form>

        <div className="admin-back">
          <a href="/">Back to main site</a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
